import React from "react";
import SalaryDetails from "./salary-details-list";

export const ParentSalaryDetails = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "parent-salary-details",
      element: <SalaryDetails />,
    },
  ],
};
